var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { AnchorItem } from "./components/AnchorItem";
import { Grid, Wrapper } from "./style";
import useCommonProps from "../../hooks/useCommonProps";
export var AnchorNavigation = function () {
    var _a;
    var _b = useCommonProps(), longreadId = _b.longreadId, teamExtraFilter = _b.teamExtraFilter, isLMSmoderationType = _b.isLMSmoderationType, isEditable = _b.isEditable, additionalContent = _b.additionalContent;
    var lgBlocks = (_a = useSelector(function (state) { return state.longreadBlocks[longreadId]; })) === null || _a === void 0 ? void 0 : _a.blocks;
    var _c = useState(function () { return window.location.hash.replace('#', ''); }), activeHash = _c[0], setActiveHash = _c[1];
    var navigationVisible = useMemo(function () {
        var _a;
        return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.anchors) === null || _a === void 0 ? void 0 : _a.anchorVisible);
    }, [additionalContent]);
    var list = useMemo(function () {
        return lgBlocks === null || lgBlocks === void 0 ? void 0 : lgBlocks.reduce(function (acc, val) {
            if (val === null || val === void 0 ? void 0 : val.anchorText) {
                return __spreadArray(__spreadArray([], acc, true), [{
                        text: val === null || val === void 0 ? void 0 : val.anchorText,
                        id: val === null || val === void 0 ? void 0 : val.postId
                    }], false);
            }
            return __spreadArray([], acc, true);
        }, []);
    }, [lgBlocks]);
    if (!navigationVisible || !isLMSmoderationType || !(list === null || list === void 0 ? void 0 : list.length)) {
        return null;
    }
    return (React.createElement(Wrapper, null,
        React.createElement(Grid, null, list === null || list === void 0 ? void 0 : list.map(function (_a) {
            var text = _a.text, id = _a.id;
            var link = id;
            return (React.createElement(AnchorItem, { key: "anchor_".concat(id), href: link, text: text }));
        }))));
};
//# sourceMappingURL=AnchorNavigation.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { AnchorItem } from "./components/AnchorItem";
import { Grid, Wrapper } from "./style";
import useCommonProps from "../../hooks/useCommonProps";
export var AnchorNavigation = function () {
    var _a;
    var _b = useCommonProps(), longreadId = _b.longreadId, teamExtraFilter = _b.teamExtraFilter, isLMSmoderationType = _b.isLMSmoderationType, isEditable = _b.isEditable, additionalContent = _b.additionalContent;
    var lgBlocks = (_a = useSelector(function (state) { return state.longreadBlocks[longreadId]; })) === null || _a === void 0 ? void 0 : _a.blocks;
    var _c = useState(function () { return window.location.hash.replace('#', ''); }), activeHash = _c[0], setActiveHash = _c[1];
    var navigationVisible = useMemo(function () {
        var _a;
        return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.anchors) === null || _a === void 0 ? void 0 : _a.anchorVisible);
    }, [additionalContent]);
    var list = useMemo(function () {
        return lgBlocks === null || lgBlocks === void 0 ? void 0 : lgBlocks.reduce(function (acc, val) {
            if (val === null || val === void 0 ? void 0 : val.anchorText) {
                return __spreadArray(__spreadArray([], acc, true), [{
                        text: val === null || val === void 0 ? void 0 : val.anchorText,
                        id: val === null || val === void 0 ? void 0 : val.postId
                    }], false);
            }
            return __spreadArray([], acc, true);
        }, []);
    }, [lgBlocks]);
    if (!navigationVisible || !isLMSmoderationType || !(list === null || list === void 0 ? void 0 : list.length)) {
        return null;
    }
    return (React.createElement(Wrapper, null,
        React.createElement(Grid, null, list === null || list === void 0 ? void 0 : list.map(function (_a) {
            var text = _a.text, id = _a.id;
            var link = id;
            return (React.createElement(AnchorItem, { key: "anchor_".concat(id), href: link, text: text }));
        }))));
};
//# sourceMappingURL=AnchorNavigation.js.map